export default "__VITE_ASSET__CtDIrCT7__"